import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Calendar, Image as ImageIcon, Users, LifeBuoy, ArrowRight } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const cards = [
  { to: "/admin/events", label: "Events", icon: Calendar, key: "events", copy: "Upcoming rallies, distributions, past events." },
  { to: "/admin/gallery", label: "Gallery", icon: ImageIcon, key: "gallery", copy: "Photos grouped by event or category." },
  { to: "/admin/leaders", label: "Leaders", icon: Users, key: "leaders", copy: "Board members and their memory pairings." },
  { to: "/admin/resources", label: "Resources", icon: LifeBuoy, key: "resources", copy: "Crisis lines, support orgs, treatment links." },
];

export default function AdminHome() {
  const { user } = useAuth();
  const [counts, setCounts] = useState({});

  useEffect(() => {
    (async () => {
      const out = {};
      for (const c of cards) {
        try {
          const { data } = await api.get(`/${c.key}`);
          out[c.key] = data.length;
        } catch { out[c.key] = "?"; }
      }
      setCounts(out);
    })();
  }, []);

  return (
    <div data-testid="admin-home">
      <div className="mb-8">
        <p className="text-xs uppercase tracking-[0.25em] font-bold text-[var(--rts-red)] mb-2">Welcome{user ? `, ${user.name || user.email}` : ""}</p>
        <h1 className="font-display text-3xl sm:text-4xl text-[var(--rts-ink)]">Reversing the Stigma - Content Manager</h1>
        <p className="text-[var(--rts-ink-soft)] mt-2 max-w-xl">Add or update content across the site. Changes go live immediately.</p>
      </div>

      <div className="grid sm:grid-cols-2 gap-4">
        {cards.map((c) => (
          <Link key={c.to} to={c.to} className="group bg-white rounded-2xl border-2 border-[var(--rts-blue-pale)] hover:border-[var(--rts-blue)] p-6 transition hover:-translate-y-0.5" data-testid={`admin-card-${c.key}`}>
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 rounded-xl bg-[var(--rts-blue-deep)] group-hover:bg-[var(--rts-red)] transition text-white grid place-items-center shrink-0">
                <c.icon className="w-6 h-6" />
              </div>
              <div className="flex-1">
                <div className="flex items-baseline justify-between gap-2">
                  <h2 className="font-display text-xl text-[var(--rts-ink)]">{c.label}</h2>
                  <span className="text-sm text-[var(--rts-muted)]">{counts[c.key] ?? "…"} items</span>
                </div>
                <p className="text-sm text-[var(--rts-ink-soft)] mt-1">{c.copy}</p>
                <span className="mt-3 inline-flex items-center gap-1 text-sm font-bold text-[var(--rts-blue-deep)]">
                  Manage <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition" />
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
